import React, { useEffect, useState } from 'react';
import './App.css';
import OcrUpload from './components/OcrUpload';
import LoginForm from './components/LoginForm';
import api from './services/api';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initSession = async () => {
      try {
        await api.get('auth/csrf/', { validateStatus: () => true });
        const res = await api.get('auth/me/', { validateStatus: status => status >= 200 && status < 500 });
        if (res.status === 200 && res.data?.user) {
          setUser(res.data.user);
        } else {
          setUser(null);
        }
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    initSession();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = async () => {
    try {
      await api.post('auth/logout/');
    } catch (err) {
      console.error(err);
    } finally {
      setUser(null);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src="/VMR_Logo.png" alt="View My Records" className="site-logo" />
        <h1 className="app-title">Ultimate MultiLingual Document OCR</h1>

        {user && (
          <div className="session-info">
            <span>Signed in as <strong>{user.username}</strong></span>
            <button type="button" className="logout-btn" onClick={handleLogout}>Sign out</button>
          </div>
        )}
      </header>

      <main>
        {loading ? (
          <div className="app-loader">Checking session…</div>
        ) : user ? (
          <OcrUpload user={user} />
        ) : (
          <LoginForm onLogin={handleLogin} />
        )}
      </main>
    </div>
  );
}

export default App;
